import { render, staticRenderFns } from "./DetailsContainer.vue?vue&type=template&id=cd257b44&"
var script = {}
import style0 from "./DetailsContainer.vue?vue&type=style&index=0&id=cd257b44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports